<template>
    <div>
        <ModalCommon :id="`ModalPreviewForm`" :config="prvFormConfig" @close="handleClosePreview()" :isView="true">
            <div class="mb-1">
                <a :href="`/manager-form/preview?id=${formData.id}&type=${formData?.page_type?.alias}`" target="_blank">{{
                    ID_PAGE_TYPE.I === formData?.page_type?.id
                        ? $t('managerForm.settingPage.screenEmail')
                        : ID_PAGE_TYPE.B === formData?.page_type?.id
                          ? $t('managerForm.settingPage.pageTypeB.enterSericode')
                          : ''
                }}</a>
            </div>
            <div class="mb-1">
                <a :href="`/manager-form/preview?id=${formData.id}&type=a`" target="_blank">{{ $t('managerForm.settingPage.screenInput') }}</a>
            </div>
        </ModalCommon>
    </div>
</template>

<script>
import ModalCommon from '@/components/Modal/main.vue';

import { ID_PAGE_TYPE } from '@/views/pages/phase2/manager-form/constants';

export default {
    name: 'ModalPreviewForm',
    components: {
        ModalCommon
    },
    props: {
        formData: {
            type: Object,
            default: () => ({})
        },
        prvFormConfig: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            ID_PAGE_TYPE
        };
    },
    methods: {
        handleClosePreview() {
            this.prvFormConfig.model = false;
        }
    }
};
</script>

<style lang="scss" scoped></style>
